import { TextInput } from "@lib/base/modules/form/components/controls/text-input/text-input.component";
import { CloseAlertQueryGraphql } from "@workspace/pages/alerts/close-alert-dialog/close-alert.graphql";
import { Validators } from "@angular/forms";

export const closeAlertDialogFormDefinition = {
    formDefinition: [
        TextInput({
            controlKey: "closingDescription",
            label: "models.Alerte.closingDescription",
            validators: [Validators.required],
        }),
    ],
    input: "Alerte",
    query: CloseAlertQueryGraphql,
};
